import ClienteModel from "@/models/clienteModel";
import SituacaoEntrega from "@/models/enum/situacaoEntrega";
import TiposPessoa from "@/models/enum/tiposPessoa";
import FormaFarmaceuticaModel from "@/models/formaFarmaceuticaModel";
import FornecedorModel from "@/models/fornecedorModel";
import PacienteModel from "@/models/paciente/pacienteModel";
import PosologiaModel from "@/models/posologiaModel";
import PrescritorModel from "@/models/prescritorModel";
import ProdutoModel from "@/models/produto/produtoModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import ServicoEntregaModel from "@/models/servicoEntregaModel";
import UnidadeMedidaModel from "@/models/unidadeMedidaModel";

import { editaCnpj } from "../formatText";

export function getProdutoComboText(item: ProdutoModel, mostrarSinonimos = true) {
    return (
        `${item.id} - ` +
        item.descricao +
        (mostrarSinonimos && item.sinonimos != null && item.sinonimos != "" ? " ((" + item.sinonimos + "))" : "") +
        (item.ativo ? "" : " - [INATIVO]")
    );
}

export function getProdutoCombo(item: ProdutoModel) {
    return {
        value: item.id,
        text: getProdutoComboText(item),
    };
}

export function getFormaFarmaceuticaCombo(item: FormaFarmaceuticaModel) {
    return {
        value: item.id,
        text: getFormaFarmaceuticaComboText(item),
    };
}

export function getFormaFarmaceuticaComboText(item: FormaFarmaceuticaModel) {
    return item.descricao + (item.ativo ? "" : " - [INATIVO]");
}

export function getUnidadeMedidaCombo(item: UnidadeMedidaModel) {
    return {
        value: item.id,
        text: item.sigla.toLowerCase(),
        type: item.unidadeMedida,
    };
}

export function getProdutoLoteComboText(item: ProdutoLoteModel, exibeCodigo: boolean, complemento = "") {
    const descricao = exibeCodigo && item.id > 0 ? `${item.descricao} (${item.id})` : item.descricao;

    return complemento ? `${descricao} - ${complemento}` : descricao;
}

export function getProdutoLoteCombo(item: ProdutoLoteModel, exibeCodigo: boolean) {
    return {
        value: item.id,
        text: getProdutoLoteComboText(item, exibeCodigo),
    };
}

export function getPacienteCombo(item: PacienteModel) {
    return {
        value: item.id,
        text: `${item.nome} - (${item.clienteDescricao})`,
    };
}

export function getPosologiaCombo(item: PosologiaModel) {
    return {
        value: item.id,
        text: `${item.id}-${item.descricao}`,
        ativo: item.ativo,
    };
}

export const getClienteCombo = (item: ClienteModel) => ({
    value: item.id,
    text: `${item.id} - ` + (item.tipoPessoa != 1 ? item.nome : item.razaoSocial) + (item.ativo ? "" : " - [INATIVO]"),
});

export const getPrescritorCombo = (item: PrescritorModel) => ({
    value: item.id,
    text: `${item.ativo ? "" : "[INATIVO]"} ${item.nome} - (${item.ufConselhoRegionalDescricao} ${
        item.numeroRegistro
    })`,
});

export function getFornecedorCombo(item: FornecedorModel) {
    return {
        value: item.id!,
        text: `${item.ativo ? "" : "[INATIVO] - "}${item.nome} ${
            item.tipoPessoa == TiposPessoa.Juridica ? " - " + editaCnpj(item.cnpj) : ""
        }`,
        contaGerencialId: item.contaGerencialId,
    };
}

export const getServicoEntregaCombo = (item: ServicoEntregaModel) => ({
    value: item.id,
    text: item.codigo ? `${item.codigo} - ${item.descricao}` : item.descricao,
});

export function getSituacaoEntregaCombo() {
    return [
        { text: "Orcamento", value: SituacaoEntrega.Orcamento },
        { text: "Em Produção", value: SituacaoEntrega.EmProducao },
        { text: "Em Execução", value: SituacaoEntrega.EmExecucao },
        { text: "Saiu para Entrega", value: SituacaoEntrega.SaiuParaEntrega },
        { text: "Entregue", value: SituacaoEntrega.Entregue },
        { text: "Cancelado", value: SituacaoEntrega.Cancelado },
    ];
}
